import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import { media, mediaQuery } from '../../common/styles/styleUtil';

interface CardProps {
  isOnProjectPage?: boolean;
  projectCard?: boolean;
  trendingCard?: boolean;
  smallCard?: boolean;
}

export const CardWrapper = styled.div<CardProps>`
  width: ${(props) =>
    props.isOnProjectPage && !props.projectCard ? 360 : 356}px;
  display: block;
  background-color: #ffffff;
  -webkit-box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  ${media.lg`
    max-width: 1024px !important;
    width: ${(props: CardProps) => (props.trendingCard || props.projectCard ? '344px' : '350px')};
  `};
  @media (${mediaQuery.mobile}) {
    display: flex;
    box-shadow: none;
  }
  ${media.xs`
    display: ${(props: CardProps) => (props.trendingCard || props.projectCard ? 'block' : 'flex')};
    width: ${(props: CardProps) => (props.trendingCard || props.projectCard ? '300px' : 'initial')};
    box-shadow: ${(props: CardProps) =>
      props.trendingCard || props.projectCard || props.smallCard
        ? '0 1px 2px 0 rgba(0, 0, 0, 0.3)'
        : 'none'};
  `};
  ${ifProp(
    'smallCard',
    css`
      width: 260px;
      min-height: 297px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
      @media (${mediaQuery.tablet}) {
        width: 262px;
      }
      @media (${mediaQuery.mobile}) {
        width: 262px;
      }
      ${media.xs`
        display: block;
      `}
    `,
  )}
`;

interface CardImageProps {
  projectCard?: boolean;
  trendingCard?: boolean;
  smallCard?: boolean;
  isOnLatestSection?: boolean;
}

export const CardImage = styled.div<CardImageProps>`
  position: relative;
  width: 100%;
  height: ${(props) => (props.projectCard ? 210 : 220)}px;
  background-color: #f3f4f6;
  overflow: hidden;
  a {
    display: flex;
    width: 100%;
    height: 100%;
    @media (${mediaQuery.mobile}) {
      width: 150px;
      height: 122px;
    }
    ${media.xs`
      width: ${(props: CardImageProps) => (props.trendingCard || props.projectCard ? 300 : 150)}px;
      height: ${(props: CardImageProps) => (props.trendingCard || props.projectCard ? 210 : 122)}px;
    `};
    ${ifProp(
      'smallCard',
      css`
        @media (${mediaQuery.tablet}) {
          width: 100%;
          height: 147px;
        }
      `,
    )}
    .img-wrapper {
      display: flex;
      width: 100%;
      height: 100%;
    }
    .play-icon-wrapper {
      width: 55px;
      height: 55px;
      font-size: 14px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .lazy-image-wrapper {
      height: 100%;
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    iframe {
      ${media.xs`
        width: ${(props: CardImageProps) => (props.isOnLatestSection ? 150 : 300)}px;
        height: ${(props: CardImageProps) => (props.isOnLatestSection ? 122 : 210)}px;
      `};
    }
  }
  @media (${mediaQuery.mobile}) {
    width: 150px;
    height: 122px;
    overflow: initial;
  }
  ${media.xs`
    width: ${(props: CardImageProps) =>
      props.trendingCard || props.projectCard ? 300 : 150}px;
    height: ${(props: CardImageProps) =>
      props.trendingCard || props.projectCard ? 210 : 122}px;
  `};
  ${ifProp(
    'smallCard',
    css`
      height: 147px;
      @media (${mediaQuery.tablet}) {
        width: 262px;
        height: 147px;
      }
    `,
  )}
`;

export const CardContent = styled.div<CardImageProps>`
  overflow: hidden;
  padding: ${(props) => (props.projectCard ? '16px 16px 0' : '16px')};
  text-align: left;
  ${ifProp(
    'smallCard',
    css`
      padding: 16px 16px 24px;
    `,
  )}
  @media (${mediaQuery.mobile}) {
    padding: ${(props) => (props.trendingCard ? '16px' : '0 0 0 8px')};
    ${ifProp(
      'projectCard',
      css`
        padding: 16px 16px 0;
      `,
    )}
    ${ifProp(
      'smallCard',
      css`
        padding: 16px 16px 24px;
      `,
    )}
  }
`;

export const CardCategory = styled.div<CardImageProps>`
  margin: 0 0 4px;
  p {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    color: #697684;
    letter-spacing: 2px;
    text-transform: uppercase;
    line-height: ${(props) => (props.smallCard ? 'normal' : '14px')};
    text-align: ${(props) => (props.smallCard ? 'center' : 'left')};
    ${media.xs`
      height: 14px;
      font-size: 12px;
      line-height: 12px;
    `}
  }
`;

interface CardTitleProps {
  projectCard?: boolean;
  isOnSearchPage?: boolean;
  smallCard?: boolean;
}

export const CardTitle = styled(
  ({
    projectCard,
    isOnSearchPage,
    className,
    children,
  }: CardTitleProps & { className?: string; children: React.ReactNode }) =>
    projectCard && isOnSearchPage ? (
      <h2 className={className}>{children}</h2>
    ) : (
      <h3 className={className}>{children}</h3>
    ),
)<CardTitleProps>`
  height: ${(props) => (props.projectCard ? '21px' : '60px')};
  margin: 0 0 7px;
  font-size: 16px;
  text-align: ${(props) => (props.smallCard ? 'center' : 'left')};
  ${ifProp(
    'smallCard',
    css`
      height: auto;
    `,
  )}
  a {
    display: -webkit-box;
    height: ${(props) => (props.smallCard ? 'auto' : '60px')};
    margin: 0;
    font-weight: 400;
    color: #333f48;
    line-height: 1.35;
    letter-spacing: normal;
    -webkit-line-clamp: ${(props) => (props.smallCard ? 2 : 3)};
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    ${ifProp(
      'projectCard',
      css`
        display: block;
        height: auto;
        -webkit-line-clamp: 0;
        -webkit-box-orient: unset;
        text-overflow: ellipsis;
        white-space: nowrap;
      `,
    )}
    ${ifProp(
      'smallCard',
      css`
        height: auto;
        max-height: 42px;
      `,
    )}
    @media (${mediaQuery.mobile}) {
      line-height: 1.25;
    }
  }
  a:hover {
    color: inherit;
  }
`;
export const Author = styled.div`
  margin: 0 0 8px;
  p {
    height: 17px;
    margin: 0;
    font-size: 13px;
    color: #797979;
    line-height: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${media.xs`
      height: 15px;
      line-height: 15px;
    `}
    a {
      color: #2b6ed2;
      font-weight: 500;
      text-decoration: none;
    }
  }
`;

export const CommentCount = styled.div`
  p {
    height: 14px;
    margin: 0;
    line-height: 14px;
    font-size: 12px;
    span {
      color: #797979;
      &:last-child {
        color: #87919d;
        font-weight: 300;
      }
    }
  }
`;

export const ProjectPostingWrapper = styled.div`
  border-top: 1px solid #d2d6da;
  height: 41px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 41px;
  .post-item {
    display: inline-block;
  }
  a {
    margin-right: 20px;
    text-decoration: none;
    @media (${mediaQuery.tablet}) {
      margin-right: 15px;
    }
    ${media.xs`
      margin-right: 10px;
    `};
  }
  a:hover {
    color: inherit;
  }
`;

export const ProjectInfoWrapper = styled.div`
  margin-bottom: 16px;
  .roomTypePlaceholder {
    height: 19px;
    margin-bottom: 12px;
  }
  .priceLevelPlaceHolder {
    height: 24px;
    margin-bottom: 16px;
  }
`;

export const Address = styled.div`
  width: 100%;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 8px;
  line-height: 1.14;
  height: 16px;
  span {
    text-transform: capitalize;
  }
`;

export const PriceLevel = styled.div`
  display: inline-block;
  height: 24px;
  margin: 0;
  padding: 4px 12px;
  background-color: rgba(105, 118, 132, 0.15);
  color: #2b6ed2;
  border-radius: 8px;
  text-transform: uppercase;
  line-height: normal;
  a {
    display: inline-block;
    height: 16px;
  }
`;

interface CardDescriptionProps {
  height?: string;
  lineClamp?: number;
  smallCard?: boolean;
}

export const CardDescription = styled.div<CardDescriptionProps>`
  height: ${(props) => props.height};
  margin: 8px 0 0;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: ${(props) => (props.smallCard ? 'center' : 'left')};
  color: #333f48;
  display: -webkit-box;
  -webkit-line-clamp: ${(props) => props.lineClamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
  ${media.xs`
    display: ${(props: CardDescriptionProps) => (props.smallCard ? '-webkit-box' : 'none')};
  `};
`;

export default CardWrapper;
